import apiContainer from '@/services/api';
import QueriesController from './queriesController.service';
import CommandsController from './commandController.service';
import * as Paths from '../paths';

const API = apiContainer.apiController();
const QueriesControllerFactory = () => new QueriesController(API, Paths);
const CommandsControllerFactory = () => new CommandsController(API, Paths);

const container = {
  queriesController: QueriesControllerFactory(),
  commandsController: CommandsControllerFactory(),
};

Object.freeze(container);

export default container;

